import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {FunctieModalComponent} from "../../../functie/modal/functie-modal.component";
import {OpleidingModalComponent} from "../../../opleiding/modal/opleiding-modal.component";
import {PersonalSelectionModalComponent} from "../../../profile/match/modal/personal-selection-modal.component";

@Component({
  selector: 'app-chatter-modal',
  templateUrl: './chatter-modal.component.html',
  styleUrls: ['./chatter-modal.component.scss']
})
export class ChatterModalComponent {
  @Input()
  public buttonLabel: string;

  @Input()
  public displayMode: string = 'button';

  @Input()
  public blueprint: any;

  @Input()
  public entityFilters: any = {};

  @Output()
  public selected: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  public notFound: EventEmitter<boolean> = new EventEmitter<boolean>();

  private _blueprint: any = null;

  public constructor(private matDialog: MatDialog) {}

  public open(): void {
    switch (this.blueprint) {
      case 'FunctieModalComponent': this._blueprint = FunctieModalComponent; break;
      case 'OpleidingModalComponent': this._blueprint = OpleidingModalComponent; break;
      case 'PersonalSelectionModalComponent': this._blueprint = PersonalSelectionModalComponent; break;
      default: this.blueprint = null;
    }
    const ref: any = this.matDialog.open(this._blueprint, {
      height: '100%',
      width: '100%',
      maxHeight: '100%',
      maxWidth: '100%',
      data: {
        entityFilters: this.entityFilters
      }
    });
    ref.componentInstance.ref = ref;
    ref.afterClosed().subscribe(result => {
      if (result) {
        this.selected.emit(result);
        this.notFound.emit(false);
      }
      if (result === 'NOT_FOUND') {
        this.selected.emit(null);
        this.notFound.emit(true);
      }
    });
  }
}
